var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00015 17.0999C13.4737 17.0999 17.1001 13.4734 17.1001 8.9999C17.1001 4.5264 13.4737 0.899902 9.00015 0.899902C4.52664 0.899902 0.900146 4.5264 0.900146 8.9999C0.900146 13.4734 4.52664 17.0999 9.00015 17.0999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 13.2188C9.31115 13.2188 9.56299 12.9669 9.56299 12.6562C9.56299 12.3456 9.31115 12.0938 9.00049 12.0938C8.68983 12.0938 8.43799 12.3456 8.43799 12.6562C8.43799 12.9669 8.68983 13.2188 9.00049 13.2188Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.125V9.5625C9.38938 9.5625 9.77002 9.44704 10.0938 9.23071C10.4175 9.01438 10.6699 8.7069 10.8189 8.34716C10.9679 7.98742 11.0069 7.59157 10.9309 7.20967C10.855 6.82777 10.6675 6.47697 10.3921 6.20163C10.1168 5.9263 9.76598 5.73879 9.38408 5.66283C9.00218 5.58687 8.60633 5.62585 8.24659 5.77486C7.88685 5.92387 7.57937 6.17621 7.36304 6.49997C7.14672 6.82373 7.03125 7.20437 7.03125 7.59375",
    stroke: "white",
    strokeOpacity: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.85b6fbef4ff8349a534408e9cdaac973.svg";
export { ForwardRef as ReactComponent };